export default __webpack_public_path__ + "static/media/footer_map2.b214ddb1.png";